/**
 * Helpers centralizados de género para los contactos.
 *
 * Modelo acordado:
 * - El valor guardado de `interestGender` es 'Caballero' | 'Dama' | null.
 *   `null` = interesado en AMBOS géneros (es la ÚNICA forma de decir "ambos";
 *   ya NO existe el valor 'Ambos'). Si quedara algún 'Ambos' legado, se trata
 *   como null (= ambos).
 * - Los chips son dos toggles independientes (Caballero / Dama): una sola
 *   marcada guarda ese género; las dos o ninguna marcadas guardan null (ambos).
 * - "Ambos" sigue existiendo SOLO como etiqueta derivada para mostrar, nunca
 *   como valor persistido.
 */

// pressed -> valor guardado: una sola marcada = ese género; ambas o ninguna = null (ambos)
export const togglesToGender = (caballero, dama) => {
  if (caballero && !dama) return 'Caballero';
  if (dama && !caballero) return 'Dama';
  return null;
};

// valor guardado -> chips: null (o legacy 'Ambos') = las dos marcadas
export const genderToToggles = (g) => {
  if (g === 'Caballero') return { caballero: true, dama: false };
  if (g === 'Dama') return { caballero: false, dama: true };
  return { caballero: true, dama: true };
};

// etiqueta visible: null/'Ambos' -> 'Ambos'
export const genderLabel = (g) => (g === 'Caballero' || g === 'Dama' ? g : 'Ambos');
